import { AuthAction } from "../AuthAction";
import { AuthActionResponse } from "../AuthActionResponse";
import { AuthActionTypeEnum } from "../AuthActionTypeEnum";

export class DeleteInstallationsAuthActionResponse implements AuthActionResponse {
    readonly type: AuthActionTypeEnum = AuthActionTypeEnum.DeleteInstallations;
    expirationDate: Date;
    installationNames: string[] = [];

    constructor(expirationDate: Date, unparsedParams: any) {
        this.expirationDate = new Date(expirationDate);
        this.parseParams(unparsedParams);
    }

    private parseParams(unparsedParams: any): void {
        if (unparsedParams.InstallationNames && unparsedParams.InstallationNames.InstallationName && unparsedParams.InstallationNames.InstallationName.length > 0) {
            if (Array.isArray(unparsedParams.InstallationNames.InstallationName)) this.installationNames = unparsedParams.InstallationNames.InstallationName;
            else {
                this.installationNames = [];
                this.installationNames.push(unparsedParams.InstallationNames.InstallationName);
            }
        }
    }
}
